/*
 * @Description: Description
 * @Author: Dai Guo
 * @Date: 2021-08-03 19:31:35
 * @LastEditors: guten2 guorui.teng@ingka.com
 * @LastEditTime: 2022-10-30 19:19:22
 */

import ikea from 'ikea-jssdk';
import DefaultModule from '@/ikea-routers/defaultModule';
import Account from '@/ikea-routers/account.ts';
import { appSaveImage } from './app';
import { getCookie } from '../utils/util';


// 是否登录
const isLogin = async () => {
  const res = await ikea.isLogin();

  return res;
};


const goLogin = ({
  templateId, templateType, fn,
}) => {
  if (sessionStorage.getItem('currentPlatform') === 'ikeacn') {
    isLogin().then(({ value }) => {
      if (!value) {
        if (templateId && templateType) {
          // eslint-disable-next-line
          ikea.navigateTo(Account.Login({ redirectUri: `${window.location.origin}/kitchen-online`}));
        } else {
          ikea.navigateTo(Account.Login(
            {
              redirectUri:
                `${window.location.origin}/kitchen-online/`,
            },
          ));
        }
      } else if (fn) {
        fn();
      }
    });
  } else {
    isLogin().then(({ value }) => {
      if (!value) {
        ikea.navigateTo(Account.Login());
      } else if (fn) {
        fn();
      }
    });
  }
};


// 设备类型
const currentPlatform = async () => {
  const res = await ikea.currentPlatform();
  const {
    value: {
      platform,
    } = {},
  } = res;

  return platform;
};


// 回到首页
const goHome = (initState) => {
  const type = localStorage.getItem('currentPlatform');
  // 是否是leads跳转过来的
  if (sessionStorage.getItem('referrer')
  && sessionStorage.getItem('referrer').indexOf(process.env.REACT_APP_LEADS_HOST) !== -1) {
    // 是否点击了预约设计师， app 是0因为预约设计师是弹窗，不是push页面
    const isClickDesign = (sessionStorage.getItem('clickToMakeAppointment') && type !== 'app') ? 1 : 0;
    const arrowShowLen = initState?.isgoEdit ? 1 : 0; // 进入过修改加1，否则为0
    const length = window.history.length - isClickDesign - arrowShowLen
    - sessionStorage.getItem('initialHistoryLength') ?? 0;
    if (sessionStorage.getItem('fromCaseDetail')) {
      document.querySelector('body').style.overflow = 'auto';
      window.history.go(-length);
    } else {
      window.history.go(-length - 1);
    }
    sessionStorage.removeItem('clickToMakeAppointment');
    sessionStorage.removeItem('fromCaseDetail');
    // sessionStorage.removeItem('initialHistoryLength');
    return;
  }

  switch (type) {
    case 'ikeacn':
      ikea.navigateTo({
        app: {
          path: '/app/index',
        },
        smp: {
          path: '/pages/index/index',
          isTab: true,
        },
        web: {
          visitPath: '/',
        },
      });
      break;
    case 'smp':
      // ikea.navigateTo({
      //   smp: {
      //     path: '/pages/index/index',
      //     isTab: true,
      //   },
      // });
      ikea.navigateBack({
        delta: window.history.length,
      });
      break;
    case 'app':
      window.flutter_inappwebview.callHandler('popCurrent');
      break;
    default:
      break;
  }
};

// async function getCscChannel() {
//   let channel = 'H5';
//   try {
//     const res = await ikea.currentPlatform();
//     const {
//       value: {
//         platform,
//       } = {},
//     } = res;
//     switch (platform) {
//       case 'iOS':
//         channel = 'IOS';
//         break;
//       case 'ANDROID':
//         channel = 'ANDROID';
//         break;
//       case 'WechatMiniprogram':
//         channel = 'SMP';
//         break;
//       case 'PcWeb':
//         channel = 'WEB';
//         break;
//       case 'MobileWeb':
//         channel = 'Mobile_Web';
//         break;
//       case 'unknown':
//       default:
//         channel = 'H5';
//         break;
//     }
//   } catch (err) {
//     console.log(err);
//   }
//   return channel;
// }

// 跳转CSC客服
const toCSC = ({ autoText = '', channel = 'default' }) => {
  console.log(autoText);

  const current = localStorage.getItem('currentPlatform');
  if (current === 'smp') {
    ikea.navigateTo(
      DefaultModule.CustomerService({
        channel,
        autoText,
        configId: '1e10444e-34we-2341-afre-293ajkfienw0',
      }),
    );
  } else if (current === 'app') {
    ikea.navigateTo(
      DefaultModule.CustomerService({
        channel,
        autoText,
        configId: '1e10444e-34we-4532-4444-375ajkfienw2',
      }),
    );
  } else {
    // window.location.href = 'https://kefu.csc.ikea.cn/webim/im.html'
    // // + '?configId=4ddd4cac-0db9-42c0-907b-2ef3c9b6dd9a';
    // + '?configId=1e10444e-34we-4532-4444-375ajkfienw2';
    // eslint-disable-next-line max-len
    window.location.href = `https://res.app.ikea.cn/page/customer_service.html?configId=1e10444e-34we-4532-4444-375ajkfienw2&channel=kitchen&autoText=${autoText}`;
  }
};

// eslint-disable-next-line max-len
// const isProd = () => window.location.host === 'kitchen-online-web.aidesign.ingka-internal.cn' || window.location.host === 'kitchen.web.ikea.cn';

const jumpNewCSC = async ({ autoText = '' }) => {
  ikea.navigateTo(DefaultModule.CustomerService({
    page: 'Kitchen',
    intent: 'Kitchen',
    autoText,
  }))
    .then((data) => {
      if (data.type === 'success') {
        // 调用成功
        console.log('ikea sdk: 联系客服调用成功');
      }
      if (data.type === 'fail') {
        console.log('ikea sdk: 联系客服调用失败');
      }
    })
    .catch((err) => {
      console.log(err);
    });
  // const channel = await getCscChannel();
  // const cscUrl = isProd()
  //   ? 'https://kefu.csc.ikea.cn/webim/im.html' : 'https://cnos-ppe-im.ingka-dt.cn/webim/im.html';
  // const url = `${cscUrl}?channel=${channel}&page=Kitchen&autoText=${autoText}`;
  // return ikea.openH5(url)
  //   .then((data) => {
  //     if (data.type === 'success') {
  //       // 调用成功
  //       console.log('ikea sdk: 联系客服调用成功');
  //     }
  //     if (data.type === 'fail') {
  //       console.log('ikea sdk: 联系客服调用失败');
  //     }
  //   })
  //   .catch((err) => {
  //     console.log(err);
  //   });
};

// 分享
const share = ({
  link, path, poster, title, trackSource,
}) => {
  const pathObject = {
    app: {
      // eslint-disable-next-line
      path: '@command_shareLink({"link":"{{link}}","path":"{{path}}","poster":"{{poster}}","title":"{{title}}","trackSource":"{{trackSource}}"})',
      version: '>=2.0.0',
    },
    smp: {
      path: '@command_shareLink({"link":"{{link}}","path":"{{path}}","poster":"{{poster}}","title":"{{title}}"})',
    },
    web: {
      visitPath: '',
    },
    params: {
      link: {
        type: 'optional',
        desc: 'the full h5 link',
      },
      path: {
        type: 'optional',
        desc: 'the native path for smp、web、app',
      },
      poster: {
        type: 'required',
        desc: 'the poster that can be saved',
      },
      title: {
        type: 'required',
        desc: 'the title in wechat sharing',
      },
      trackSource: {
        type: 'optional',
        desc: 'the share source，only used in app',
      },
    },
  };
  pathObject.receivedParams = {
    link, path, poster, title, trackSource,
  };


  ikea.navigateTo(pathObject);
};

function downloadFile(content, fileName) {
  const base64ToBlob = (code) => {
    const parts = code.split(';base64,');
    const contentType = parts[0].split(':')[1];
    const raw = window.atob(parts[1]);
    const rawLength = raw.length;
    const uInt8Array = new Uint8Array(rawLength);
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < rawLength; ++i) {
      uInt8Array[i] = raw.charCodeAt(i);
    }
    return new Blob([uInt8Array], {
      type: contentType,
    });
  };
  const aLink = document.createElement('a');
  const blob = base64ToBlob(content);
  if (window.navigator.msSaveOrOpenBlob) { // IE
    window.navigator.msSaveOrOpenBlob(blob, fileName);
  } else {
    // 这里就按照chrome等新版浏览器来处理
    const evt = document.createEvent('HTMLEvents');
    evt.initEvent('click', true, true);
    aLink.download = fileName;
    aLink.href = URL.createObjectURL(blob);
    aLink.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));// 兼容火狐
  }
}

// 保存图片

// saveImg({
//   // eslint-disable-next-line
//   link: location.href,
//   poster: 'https://img2.baidu.com/it/u=2366206586,2019721192&fm=11&fmt=auto&gp=0.jpg',
//   title: '我设计的PAX帕克思衣柜',
// });
/**
 * 保存图片
 * @param {String} link 当前页面路径
 * @param {String} poster 需要保存的图片的地址
 * @param {String} title 保存的标题
 */
const saveImg = ({ link, poster, title }) => {
  // debugger;
  const type = localStorage.getItem('currentPlatform');

  switch (type) {
    case 'smp':
      ikea.navigateTo({
        app: {
          // eslint-disable-next-line
          path: '@command_shareLink({"link":"{{link}}","path":"{{path}}","poster":"{{poster}}","title":"{{title}}","trackSource":"{{trackSource}}"})',
          version: '>=2.0.0',
        },
        smp: {
          path: '@command_shareLink({"link":"{{link}}","path":"{{path}}","poster":"{{poster}}","title":"{{title}}"})',
        },
        web: {
          visitPath: '',
        },
        params: {
          link: {
            type: 'optional',
            desc: 'the full h5 link',
          },
          path: {
            type: 'optional',
            desc: 'the native path for smp、web、app',
          },
          poster: {
            type: 'required',
            desc: 'the poster that can be saved',
          },
          title: {
            type: 'required',
            desc: 'the title in wechat sharing',
          },
          trackSource: {
            type: 'optional',
            desc: 'the share source，only used in app',
          },
        },
        receivedParams: {
          link,
          poster,
          title,
        },
      });
      break;
    case 'app':
      appSaveImage(poster);
      break;
    case 'ikeacn':
      (async () => {
        // const a = document.createElement('a');
        // a.download = `${new Date().getTime()}.png`;
        // a.href = poster;
        // document.body.appendChild(a);
        // a.click();
        downloadFile(poster, `${new Date().getTime()}.png`);
      })();
      break;
    default:
      break;
  }
};


// 只有app能够获取当前的zipCode
const getCity = async () => {
  console.log('window.flutter_inappwebview', window.flutter_inappwebview);
  if (!window.flutter_inappwebview) return null;
  try {
    if (typeof window.flutter_inappwebview?.callHandler === 'function') {
      console.log('获取native city成功');
      return await window.flutter_inappwebview.callHandler('getCity');
    }
    console.log('获取native city失败');
    return new Promise((resolve) => {
      window.addEventListener('flutterInAppWebViewPlatformReady', async () => {
        console.log('等待初始化获取城市');
        const cityInfo = await window.flutter_inappwebview.callHandler('getCity');
        console.log('获取城市成功', JSON.stringify(cityInfo));
        resolve(cityInfo);
      });
    });
  } catch (e) {
    console.log('getCity:', e);
    return null;
  }
};

// 加入购物车
const addToCart = async (params, isclose = false) => {
  const type = localStorage.getItem('currentPlatform');
  switch (type) {
    case 'smp':
      ikea.navigateTo({
        smp: {
          path: '/pages/shopping_cart_non_tab/shopping_cart_non_tab?products=@command_encode({{products}})',
        },
        params: {
          products: JSON.stringify(params),
        },
      });
      break;
    case 'app':
      await window.flutter_inappwebview.callHandler('addToCart', params);
      await window.flutter_inappwebview.callHandler('push', {
        path: 'https://ikeaapp/shopping_cart',
        popCurrent: isclose, // 是否关闭当前页
      });
      break;
    case 'ikeacn':
      await ikea.request({
        path: '/shopping/cart/add-products',
        method: 'POST',
        headers: {
          'X-Client-Platform': getCookie('platform') || 'MobileWeb',
        },
        data: {
          products: params, // param: {"products": [{"productFullId": XXXX, "quantity": 1}]}
        },
      });
      window.location.href = `https://${window.location.host === 'res-qa.app.ikea.cn'
        ? 'www-qa.web.ikea.cn' : 'www.ikea.cn'}/cn/zh/pay/cart`;
      break;
    default:
      break;
  }
};

/**
 * 分享（其中就有保存）
 * @param {*} ikea sdk 需要的参数: link, poster, title
 */
const shareWX = (param) => ikea.navigateTo(DefaultModule.Share(param));

// 获取用户手机号和昵称
const getUserInfo = (fn: (r: any) => void) => {
  ikea
    .getUserInfo()
    .then((result) => {
      fn(result);
    })
    .catch(() => {
      fn(false);
    });
};

const getUserAddress = (fn: (r: any) => void) => {
  ikea
    .getAddressInfo()
    .then((result) => {
      fn(result);
    })
    .catch(() => {
      fn(false);
    });
};

export {
  isLogin,
  goLogin,
  currentPlatform,
  getCity,
  toCSC,
  saveImg,
  addToCart,
  goHome,
  share,
  shareWX,
  getUserInfo,
  getUserAddress,
  jumpNewCSC,
};

